import Container from "Components/Container/Container";
import React from "react";
import { Link } from "react-router-dom";
const Header = ({ name }) => {
  return (
    <section className="map">
      <Container>
        {" "}
        <div className="relative pt-32 lg:pt-44">
          <div className="text-2xl  text-[#808080] flex items-center  gap-x-2">
            <Link to={"/"} className="hover:underline">
              Home
            </Link>
            <span>|</span>
            <Link className="hover:underline" to={"/main-projects"}>
              {" "}
              Projects
            </Link>
          </div>

          <h2 className="text-white text-4xl md:text-5xl  lg:text-6xl xl:text-7xl bebas uppercase mt-2 tracking-[6px]">
            {name}
          </h2>
        </div>
      </Container>
    </section>
  );
};

export default Header;
